import { isObject } from "../is/isObject.js";
function instanceOfReference(object) {
  return isObject(object) && "id" in object && "collection_id" in object;
}
export {
  instanceOfReference
};
